import { IconBaseProps, IconType } from "@/types/icon";

export const BlackArrowNarrowRightlineIcon: IconType = ({
  size = 40,
  color = "text-gray-800",
  ...props
}: IconBaseProps) => {
  return (
    <svg
      className={`${color}`}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 40 40"
      {...props}
    >
      <path
        d="M0 19.9999C0 8.95418 8.95431 -0.00012207 20 -0.00012207C31.0457 -0.00012207 40 8.95418 40 19.9999C40 31.0456 31.0457 39.9999 20 39.9999C8.95431 39.9999 0 31.0456 0 19.9999Z"
        fill="black"
      />
      <path
        d="M23.1056 15.6948L25.8571 18.4463L26.7107 19.2999H25.5036H11.6004C11.4147 19.2999 11.2367 19.3736 11.1054 19.5049L10.754 19.1535L11.1054 19.5049C10.9741 19.6362 10.9004 19.8142 10.9004 19.9999C10.9004 20.1855 10.9741 20.3636 11.1054 20.4948C11.2367 20.6261 11.4147 20.6999 11.6004 20.6999H25.5036H26.7107L25.8571 21.5534L23.109 24.3016C22.9832 24.4333 22.9136 24.6089 22.9152 24.7912C22.9168 24.9747 22.9904 25.1503 23.1202 25.2801C23.2499 25.4099 23.4255 25.4835 23.6091 25.4851C23.7913 25.4867 23.967 25.4171 24.0987 25.2912L28.8952 20.4948C28.8952 20.4947 28.8952 20.4947 28.8952 20.4947C29.0264 20.3634 29.1001 20.1855 29.1001 19.9999C29.1001 19.8143 29.0264 19.6363 28.8952 19.505L23.1056 15.6948ZM23.1056 15.6948C23.1056 15.6947 23.1056 15.6947 23.1055 15.6947C22.9743 15.5634 22.9006 15.3855 22.9006 15.1999C22.9006 15.0143 22.9744 14.8362 23.1056 14.705C23.2369 14.5738 23.4148 14.5001 23.6004 14.5001C23.786 14.5001 23.964 14.5738 24.0952 14.705C24.0953 14.705 24.0953 14.7051 24.0953 14.7051L28.8952 19.505L23.1056 15.6948Z"
        fill="white"
        stroke="white"
      />
    </svg>
  );
};
